import ArtTrackIcon from '@mui/icons-material/ArtTrack';
import DeleteIcon from '@mui/icons-material/Delete';
import ImageIcon from '@mui/icons-material/Image';
import { Button, Grid, IconButton, MenuItem, TextField, Tooltip } from "@mui/material";
import Box from "@mui/material/Box";
import Divider from '@mui/material/Divider';
import List from "@mui/material/List";
import ListItem from "@mui/material/ListItem";
import React, { useRef, useState } from "react";
import { DragDropContext, Draggable, Droppable } from "react-beautiful-dnd";
import { useDispatch, useSelector } from "react-redux";
import { ADMIN_SERVER_BASE_URL, SITEWEB_SERVER_BASE_URL, apiClient } from "../../util/apiClient";
import { convertToBase64, errorNotify, successNotify } from "../../util/functions";
import { IReduxState } from '../../store';
import AddIcon from '@mui/icons-material/Add';
import PostDialog from '../../SpiderWebSite/components/PostDialog';
import Radio from '@mui/material/Radio';
import RadioGroup from '@mui/material/RadioGroup';
import FormControlLabel from '@mui/material/FormControlLabel';
import FormControl from '@mui/material/FormControl';
import FormLabel from '@mui/material/FormLabel';
import { Autocomplete } from "@mui/material";
import ListeEtab from './ListeEtab';
import { addMessage } from '../../store/focusEcoleSlice';
import { INotificationPayload } from './interface';

interface IAddProps {
  messageState: any;
  setMessageState: (x: any) => void;
  currentEtab: any;
  setCurrentEtab: any;
  alertLevel: any;
  setAlertLevel: any;
  selected: any;
  setSelected: any;
  appSelected: any;
  setAppSelected: any;
}

const dataSenders = [
  { id: "PART_SPIDER_TECH", libelle: "Spider Technologie" },
  { id: "PART_CAMPUS_FRANCE", libelle: "Campus France" },
  { id: "PART_CINETPAY", libelle: "CinetPay" }
]


const Add = (props: IAddProps) => {
  const partenaires = useSelector((state: IReduxState) => state.partenaires.partenaires);
  //props
  const {
    messageState,
    setMessageState,
    selected,
    setSelected,
    alertLevel,
    setAlertLevel,
    appSelected,
    setAppSelected
  } = props

  //redux

  const handleChange = (event: any) => {
    setAppSelected((event.target as any).value);
  };

  const handleLevelAlertInputChange = (event: any) => {
    setAlertLevel((event.target as any).value);
  };

  //fonctions
  const handleInputChange = (e: any) => {
    const { value, name } = e.target
    setMessageState({ ...messageState, [name]: value })
  }


  return (
    <Box sx={{ flexGrow: 1, width: "100%" }}>
      <Grid
        container
        spacing={2}
        direction="row"
        justifyContent="flex-start"
        alignItems="center"
      >
        <Grid item md={12} xs={12} sm={12}>
          <FormControl>
            <RadioGroup
              row
              value={appSelected}
              onChange={handleChange}
            >
              <FormControlLabel value={"FOCUS"} control={<Radio />} label="Focus-Ecole" />
              <FormControlLabel value={"PXP2021"} control={<Radio />} label="Prof-Expert" />
            </RadioGroup>
          </FormControl>
        </Grid>
        <Grid item md={12} xs={12} sm={12}><Divider /></Grid>
        <Grid item md={6} xs={12} sm={6}>
          <ListeEtab
            selected={selected}
            setSelected={setSelected}
          />
        </Grid>
        <Grid item md={6} xs={12} sm={6}>
          <Grid
            container
            spacing={2}
            direction="row"
            justifyContent="flex-start"
            alignItems="center"
          >
            <Grid item md={12} xs={12} sm={12}>
              <FormControl>
                <FormLabel>Selectionner un niveau d'alerte</FormLabel>
                <RadioGroup
                  row
                  value={alertLevel}
                  onChange={handleLevelAlertInputChange}
                >
                  <FormControlLabel value={"Info"} control={<Radio size="small" color="info" />} label="Information" />
                  <FormControlLabel value={"Success"} control={<Radio size="small" color="success" />} label="Succès" />
                  <FormControlLabel value={"Warning"} control={<Radio size="small" color="warning" />} label="Avertissement" />
                  <FormControlLabel value={"Danger"} control={<Radio size="small" color="error" />} label="Danger" />
                </RadioGroup>
              </FormControl>
            </Grid>
            <Grid item md={6} xs={12} sm={6}>
              <TextField
                fullWidth
                select
                size="small"
                name="idPartenaire"
                label="Emetteur"
                value={messageState.idPartenaire}
                onChange={handleInputChange}
              >
                {partenaires.map((option) => (
                  <MenuItem key={option.idPartenaire} value={option.idPartenaire}>
                    {option.libelle}
                  </MenuItem>
                ))}
              </TextField>
            </Grid>
            <Grid item md={6} xs={12} sm={6}>
              <TextField
                fullWidth
                size="small"
                name="messageTitle"
                label="Titre"
                value={messageState.messageTitle}
                onChange={handleInputChange}
              />
            </Grid>
            <Grid item md={12} xs={12} sm={12}>
              <TextField
                fullWidth
                multiline
                minRows={6}
                name="messageContent"
                label="Saisir le message"
                value={messageState.messageContent}
                onChange={handleInputChange}
              />
            </Grid>
          </Grid>
        </Grid>
      </Grid>
    </Box>
  );
};







export const initialState = {
  messageTitle: "",
  messageContent: "",
  alertLevel: "Info",
  codeEtabs: [],
  sendNow: true
}


const DialogAdd = (props: any) => {
  const { setFilteredMessages, filteredMessages } = props
  //redux
  const dispatch = useDispatch();
  const etabs = useSelector((state: IReduxState) => state.focusEcole.etabs);

  //hooks
  const [open, setOpen] = useState<boolean>(false)
  const [addLoading, setAddLoading] = useState<boolean>(false)
  const [messageState, setMessageState] = useState<any>(initialState)
  const [currentEtab, setCurrentEtab] = useState<any>({})
  const [alertLevel, setAlertLevel] = useState("Info")
  const [selected, setSelected] = React.useState<readonly number[]>([]);
  const [appSelected, setAppSelected] = React.useState("FOCUS");


  const onClose = () => {
    setOpen(false)
  }

  const handleOpenDialog = () => {
    setOpen(true)
  }

  const handleAddMessages = (data: any) => {
    const res = [...filteredMessages]
    setFilteredMessages([...data, ...res])
  }


  /**
   * Permet d'enregistrer une actualité dans la base de donnée
   * @param e 
   */
  const handleMessageSave = async (e: any) => {
    try {
      e.preventDefault()
      setAddLoading(true)
      const apiPayload: INotificationPayload = {
        ...messageState,
        alertLevel: alertLevel,
        anneeScolaire: etabs[0].anScol,
        codeEtabs: selected,
        targetAppId: appSelected
      }
      // console.log("🚀 ~ handleMessageSave ~ apiPayload:", apiPayload)

      // return
      const res: any = await apiClient.post(ADMIN_SERVER_BASE_URL, "/tablesystem/envoyernotifiactions", apiPayload);
      if (res.status === 1) {
        dispatch(addMessage(res.data))
        handleAddMessages(res.data)
        onClose()
        successNotify("Action effectuée avec succès");
        setAddLoading(false)
        setMessageState(initialState)
      } else {
        errorNotify("Erreur");
        setAddLoading(false)
      }
    } catch (error) {
      setAddLoading(false)
      console.log("🚀 ~ file: Add.tsx:305 ~ handleMessageSave ~ error:", error)
    }
  }


  return (
    <PostDialog
      onClose={onClose}
      open={open}
      dialogContent={
        <Add
          messageState={messageState}
          setMessageState={setMessageState}
          currentEtab={currentEtab}
          setCurrentEtab={setCurrentEtab}
          alertLevel={alertLevel}
          setAlertLevel={setAlertLevel}
          selected={selected}
          setSelected={setSelected}
          appSelected={appSelected}
          setAppSelected={setAppSelected}
        />}
      actionFunc={handleMessageSave}
      title="Envoie de notifications"
      addLoading={addLoading}
      handleOpenDialog={handleOpenDialog}
    />

  );
};
export default DialogAdd;



